import styles from "./Service.module.scss";
import useMobile from "../../../hooks/useMobile";
import { VscInfo, VscLockSmall } from "react-icons/vsc";
import { Tooltip } from "react-tooltip";
import Utilities from "../../utils/Utilities";
import StaffSelector from "../../StaffSelector/StaffSelector";
import TickIcon from "../../../assets/icons/tick-icon.svg";
import { motion, AnimatePresence } from "framer-motion";
import usePreferencesStore from "../../../store/preferencesStore";

function Service(props) {
  const isSelected = Utilities.isServiceSelected(
    props.item,
    props.selectedServices
  );
  const serviceLowerPrice = Utilities.getServiceLowerPrice(
    props.item
  ).toFixed();
  const isMobile = useMobile();

  const handleSelectButtonClick = (event) => {
    if (props.onServiceSelect) {
      props.onServiceSelect(props.item);
    }
  };

  const { preferences } = usePreferencesStore();

  const handleDeSelectButtonClick = (event) => {
    if (props.onServiceDeSelect) {
      props.onServiceDeSelect(props.item);
    }
  };

  const transformStaff = (service) => {
    const defaultItem = Utilities.getEmptyEmployee(service);
    const staffItems = [
      defaultItem,
      ...service.staff.reduce((prev, staffItem, index, array) => {
        let price = parseInt(staffItem.standard_sell_price);
        if (price === 0) {
          price = parseInt(service.standard_sell_price);
        }
        prev.push({
          id_employee: staffItem.id_employee,
          iconJsx: staffItem.iconJsx,
          label: staffItem.employee_name,
          label2:
            "da " +
            parseInt(price).toFixed(2).toString().replace(".", ",") +
            " €",
        });
        return prev;
      }, []),
    ];
    //staffItems.push(defaultItem);
    return staffItems;
  };

  const handleStaffItemSelected = (staffItem) => {
    props.item.staffItem = staffItem;
    if (props.onServiceSelect) {
      props.onServiceSelect({
        ...props.item,
        idStaffItem: staffItem.id_employee,
      });
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: props.delay ? 1 : 0 }} // Start from 50px below the bottom
        animate={{ opacity: props.delay ? 0 : 1 }} // Slide up to its original position
        transition={{ duration: 0.3 }}
      >
        <div
          id={props.item.id_service}
          className={styles["service-container"]}
          isselected={isSelected ? "yes" : "no"}
        >
          <div className={styles["service-row"]}>
            {props.item.includedServices &&
              props.item.includedServices.length > 0 && <></>}

            <div className={styles["service-col1"]}>
              <div className={styles["service-title"]}>
                {/* name */}
                {props.item &&
                  props.item.name[0].toUpperCase() +
                    props.item.name.slice(1).toLowerCase()}
                {/* info in tooltip */}
                {props.item.info && (
                  <>
                    <div
                      data-tooltip-id="info-icon-tooltip"
                      data-tooltip-content={props.item.info}
                      data-tooltip-place="top-end"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        height: "30px",
                        marginLeft: "14px",
                      }}
                    >
                      <VscInfo size="20" className={styles["info-icon"]} />
                    </div>
                    <Tooltip
                      id="info-icon-tooltip"
                      className={styles["infoTooltip"]}
                      place="top-end"
                      type="light"
                      style={{
                        width: "264px",
                        backgroundColor: "white",
                        boxShadow: "-0px -0px 10px #2222221A",
                        color: "#222",
                        opacity: "1",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "19px",
                        letterSpacing: "0em",
                        textAlign: "left",
                      }}
                    />
                  </>
                )}
              </div>
              <div className={styles["service-duration"]}>
                {/* in mobile displaying price. displaying time in desktop */}
                {isMobile ? (
                  <>
                    {preferences.mostra_prezzi_listino && (
                      <>
                        {preferences.prefix}{" "}
                        {props.item &&
                          parseInt(serviceLowerPrice)
                            .toFixed(2)
                            .toString()
                            .replace(".", ",")}{" "}
                        €
                      </>
                    )}
                  </>
                ) : (
                  `${props.item && props.item?.worker_duration} min`
                )}
              </div>
            </div>
            <div className={styles["service-col2"]}>
              {/* in desktop displaying lower price. */}
              {!isMobile && (
                <div
                  className={styles["service-price"]}
                  isselected={isSelected ? "yes" : "no"}
                >
                  {preferences.mostra_prezzi_listino && (
                    <>
                      {preferences.prefix}{" "}
                      {props.item &&
                        parseInt(serviceLowerPrice)
                          .toFixed(2)
                          .toString()
                          .replace(".", ",")}{" "}
                      €
                    </>
                  )}
                </div>
              )}
            </div>

            <div
              className={styles["service-col3"]}
              isselected={
                Utilities.isServiceSelected(props.item, props.selectedServices)
                  ? "yes"
                  : "no"
              }
            >
              <AnimatePresence>
                <motion.div
                  initial={{ opacity: props.delay ? 1 : 0 }} // Start from 50px below the bottom
                  animate={{ opacity: props.delay ? 0 : 1 }} // Slide up to its original position
                  transition={{ duration: 0.3 }}
                >
                  <button
                    className={styles["service-button-select"]}
                    style={
                      Utilities.getItemFromSelectedServices(
                        props.item,
                        props.selectedServices
                      )?.selectionMode === Utilities.INCLUDED
                        ? { display: "none" }
                        : {}
                    }
                    isselected={
                      Utilities.isServiceSelected(
                        props.item,
                        props.selectedServices
                      )
                        ? "yes"
                        : "no"
                    }
                    onClick={
                      Utilities.isServiceSelected(
                        props.item,
                        props.selectedServices
                      )
                        ? handleDeSelectButtonClick
                        : handleSelectButtonClick
                    }
                  >
                    {Utilities.isServiceSelected(
                      props.item,
                      props.selectedServices
                    ) &&
                    Utilities.getItemFromSelectedServices(
                      props.item,
                      props.selectedServices
                    )?.selectionMode === Utilities.MANUAL ? (
                      <img src={TickIcon} alt="tick-icon" />
                    ) : props.currentStep === 1.2 ? (
                      "AGGIUNGI"
                    ) : (
                      "Seleziona"
                    )}
                  </button>
                </motion.div>
              </AnimatePresence>
              {/* )} */}

              {isSelected && (
                <>
                  {Utilities.getItemFromSelectedServices(
                    props.item,
                    props.selectedServices
                  ).selectionMode === Utilities.INCLUDED && (
                    <>
                      <button
                        style={{ cursor: "default" }}
                        className={styles["service-button-select"]}
                        isselected="included"
                        onClick={handleDeSelectButtonClick}
                        data-tooltip-id="info-lock-icon-tooltip"
                        data-tooltip-content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                        data-tooltip-place="top-end"
                      >
                        <VscLockSmall size="20" stroke-width="0.5" />
                      </button>

                      <Tooltip
                        id="info-lock-icon-tooltip"
                        className={styles["infoTooltip"]}
                        place="top-end"
                        type="light"
                        style={{
                          width: "264px",
                          backgroundColor: "white",
                          boxShadow: "-0px -0px 10px #2222221A",
                          color: "#222",
                          opacity: "1",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "19px",
                          letterSpacing: "0em",
                          textAlign: "left",
                        }}
                      />
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          {isSelected &&
            (!isMobile ? (
              <div className={styles["service-row"]}>
                <AnimatePresence>
                  <motion.div
                    hidden={preferences.show_employees === false}
                    style={{
                      width: "100%",
                    }}
                    initial={{ opacity: props.delay ? 1 : 0 }} // Start from 50px below the bottom
                    animate={{ opacity: props.delay ? 0 : 1 }} // Slide up to its original position
                    transition={{ duration: 0.3 }}
                  >
                    <div className={styles["operator-container"]}>
                      <div className={styles["service-row"]}>
                        <span>seleziona operatore</span>
                      </div>
                      <div className={styles["service-row"]}>
                        <div className={styles["operator-input-main"]}>
                          <div className={styles["operator-input-main-icon"]}>
                            {props.item.staffItem
                              ? props?.item?.staffItem?.iconJsx
                              : transformStaff(props.item)[0]?.iconJsx}
                          </div>
                        </div>
                        <div className={styles["operator-input-container"]}>
                          <StaffSelector
                            items={transformStaff(props.item)}
                            defaultValueIndex="0"
                            onChange={handleStaffItemSelected}
                            selectedItem={props.item.staffItem}
                          />
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            ) : (
              <div className={styles["service-row"]}>
                <AnimatePresence>
                  <motion.div
                    hidden={preferences.show_employees === false}
                    style={{
                      width: "100%",
                    }}
                    initial={{ opacity: props.delay ? 1 : 0 }} // Start from 50px below the bottom
                    animate={{ opacity: props.delay ? 0 : 1 }} // Slide up to its original position
                    transition={{ duration: 0.3 }}
                  >
                    <div className={styles["operator-container"]}>
                      <div className={styles["service-row"]}>
                        <span>SELEZIONA OPERATORE</span>
                      </div>
                      <div className={styles["service-row"]}>
                        <StaffSelector
                          items={transformStaff(props.item)}
                          defaultValueIndex="0"
                          onChange={handleStaffItemSelected}
                          selectedItem={props.item.staffItem}
                        />
                      </div>
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            ))}
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default Service;
